{
  "name": "36ed2",
  "description": "Octave divided into 36 equal steps",
  "scale": [
    "33.3",
    "66.7",
    "100.0",
    "133.3",
    "166.7",
    "200.0",
    "233.3",
    "266.7",
    "300.0",
    "333.3",
    "366.7",
    "400.0",
    "433.3",
    "466.7",
    "500.0",
    "533.3",
    "566.7",
    "600.0",
    "633.3",
    "666.7",
    "700.0",
    "733.3",
    "766.7",
    "800.0",
    "833.3",
    "866.7",
    "900.0",
    "933.3",
    "966.7",
    "1000.0",
    "1033.3",
    "1066.7",
    "1100.0",
    "1133.3",
    "1166.7",
    "1200.0"
  ],
  "key_colors_mode": "manual",
  "short_description": "35-MT_Helmholtz",
  "built_in_group": "Equal Divisions",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "C",
    "C+33",
    "C−33",
    "C",
    "C+33",
    "D−33",
    "D",
    "D+33",
    "E−33",
    "E",
    "E+33",
    "E−33",
    "E",
    "E+33",
    "F−33",
    "F",
    "F+33",
    "F−33",
    "F",
    "F+33",
    "G−33",
    "G",
    "G+33",
    "G−33",
    "G",
    "G+33",
    "A−33",
    "A",
    "A+33",
    "B−33",
    "B",
    "B+33",
    "B−33",
    "B",
    "B+33",
    "C−33"
  ],
  "note_colors": [
    "#ffb4b4",
    "#e5b9bb",
    "#d3c6c5",
    "#d0d0d7",
    "#bfaaa9",
    "#ffe5e5",
    "#ffffff",
    "#e5b9bb",
    "#d3c6c5",
    "#d0d0d7",
    "#bfaaa9",
    "#d3c6c5",
    "#ffffff",
    "#e5b9bb",
    "#ffe5e5",
    "#ffffff",
    "#e5b9bb",
    "#d3c6c5",
    "#dee2da",
    "#bfaaa9",
    "#ffe5e5",
    "#ffffff",
    "#e5b9bb",
    "#d3c6c5",
    "#d0d0d7",
    "#bfaaa9",
    "#ffe5e5",
    "#ffffff",
    "#e5b9bb",
    "#d3c6c5",
    "#d0d0d7",
    "#bfaaa9",
    "#d3c6c5",
    "#ffffff",
    "#e5b9bb",
    "#ffe5e5"
  ],
  "equivSteps": 36,
  "fundamental": 440,
  "reference_degree": 27,
  "center_degree": 0,
  "rSteps": 6,
  "drSteps": 5,
  "hexSize": 42,
  "rotation": -21.2,
  "lumatone_anchor_note": 13,
  "lumatone_anchor_channel": 3
}
